export default __webpack_public_path__ + "static/media/moon_diffuse.26419cb1.jpg";